import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import WallarmConfigListing from './WallarmConfigListing'
import WallarmCredentialForm from './WallarmCredentialForm'

export default function WallarmPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={WallarmCredentialForm}
            PullConfigListingView={WallarmConfigListing}
        />
    )
}